import { create } from 'zustand'

const usePage = create((set) => ({
    page: 1,
    setPage: (pageNumber) => set((state) => ({ page: pageNumber }))
}))

export default usePage